export default class CursorEvent {
  constructor(options) {
    this.pixelX = options.pixelX;
    this.pixelY = options.pixelY;
    this.value = options.value;
    this.rows = options.rows;
    this.projection = options.projection;
    this.linearView = options.linearView;
    this.startAccess = options.startAccess;
    this.stopAccess = options.stopAccess;
    this.blockAccess = options.blockAccess;
    this.event = options.event;
    this.itemsAt = undefined;
  }
  getItemsAt() {
    if (this.itemsAt === undefined) {
      const items = [];
      const rows = this.rows || [];
      for (let r = 0; r < rows.length; r++) {
        const row = rows[r];
        if (Array.isArray(row)) {
          for (let i = 0; i < row.length; i++) {
            const item = row[i];
            const start = this.startAccess(item);
            const stop = this.stopAccess(item);
            if (start === undefined || stop === undefined) {
              continue;
            }
            if (start <= this.value && stop > this.value) {
              items.push({
                block: item,
                start,
                stop,
                row: r,
                index: i
              });
              continue;
            }
          }
        }
      }
      this.itemsAt = items;
    }
    return this.itemsAt;
  }
}